import { render } from "./QuizForm.vue?vue&type=template&id=b09626c2"
import script from "./QuizForm.vue?vue&type=script&lang=js"
export * from "./QuizForm.vue?vue&type=script&lang=js"

import "@/css/weeduc/admin/quiz-editor.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__